import { useLocation } from 'react-router-dom';
import Clients from '../../../pages/Clients/Clients';

const TeamMemberClients = () => {
  const location = useLocation();
  const { selectedCoachId } = location.state;

  return <Clients coachId={selectedCoachId} />;
};

export default TeamMemberClients;
